import { render } from "./ServiceStatus.vue?vue&type=template&id=0552653c&scoped=true"
import script from "./ServiceStatus.vue?vue&type=script&lang=ts"
export * from "./ServiceStatus.vue?vue&type=script&lang=ts"

import "./ServiceStatus.vue?vue&type=style&index=0&id=0552653c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0552653c"

export default script